export const getMarketingConversionEventLabel = (eventType) => {
  switch (eventType) {
    case "lead_visit":
      return "Lead";

    case "lead_created":
      return "Lead Created (Landing)";

    case "booking_initiated":
    case "reservation_payment_pending":
      return "Booking Initiated - No Payment";

    case "reservation_completed":
    case "reservation_payment_success":
      return "Booking Completed - Payment Successful";

    default:
      return "-";
  }
};

export const formatMarketingConversionPrice = (amount) => {
  const parsedAmount = parseFloat(amount);
  if (!Number.isFinite(parsedAmount)) {
    return "-";
  }

  return `$${parsedAmount.toFixed(2)}`;
};
